import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormGroupDirective, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { AuthPageManageService } from '../../../services/manage/page-manage/auth-page-manage.service';
import { Router } from '@angular/router';
import { SmsnotificationsService } from 'src/app/services/apiclient/smsnotifications/smsnotifications.service';
import {CssService} from "../../../services/css-service";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

  // Nom de la page où rediriger après authentification
  @Input() redirectPage: string|any;

  // Erreur actuelle
  error$: string|any;

  // Formulaire de login
  loginForm: FormGroup|any;

  // Email attaché à l'utilisateur
  currEmail: string|any;

  // Loader
  loaderLogin: boolean = false;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public cssService: CssService,
    public authManPag: AuthPageManageService,
    private tools: ToolsService,
    public smsApi: SmsnotificationsService
  ) { }

  ngOnInit() {
    this.createLoginForm();
    this.authService.getError.subscribe((data) => {

      this.error$ = data;

    });
  }

  createLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  isFieldrequired(field: string): boolean|any {
    const thisField:any = this.loginForm.controls[field];
    if (thisField.errors) {
      if (thisField.errors.required) {
        return true;
      }
    }
  }

  submitLogin(formDirective: FormGroupDirective): void {

    const that = this;
    const formVal = this.loginForm.value;
    that.error$ = "";

    if (that.loginForm.valid) {

      that.loaderLogin = true;
      that.currEmail = formVal.email;

      that.authService.signInEmailPass(formVal.email, formVal.password).then(data => {
        that.tools.resetForm(formDirective, that.loginForm);
        that.loaderLogin = false;

        /**
         * Si aucune erreur alors on redirige
         */
        if (!that.error$) {

          that.tools.goRedirectPage(that.redirectPage);

          //on clean l'error
          this.authService.setError(null);

        }

      });

    }
  }
}
